"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayForNonAdmin = exports.DisplayForAdmin = void 0;
exports.DisplayForRole = DisplayForRole;
exports.DisplayForTeamAdmin = void 0;
var _react = _interopRequireDefault(require("react"));
var _RoleHelper = require("../RoleHelper");
/**
 * Example usage with a role argument:
 *
 * <DisplayForRole user={user} role={['Team', 'Admin']} scope={{team: teamId}}>
      Your team admin only content
    </DisplayForRole>


 * Example usage with multiple roles (note when roles is provided, you do not provide the scope property separately):

  <DisplayForRole
      user={user}
      roles={RoleHelper.eventAdminRoles(teamId, eventId, includeTeamAdmin)}
      teamId={teamId} eventId={eventId}>
      Your content only for admin roles
  </DisplayForRole>
 *
 * @param {*} param0
 */
function DisplayForRole(_ref) {
  var user = _ref.user,
    roles = _ref.roles,
    role = _ref.role,
    scope = _ref.scope,
    teamId = _ref.teamId,
    eventId = _ref.eventId,
    children = _ref.children;
  if (!user) return _react["default"].createElement("span", null);
  if (!roles) roles = [{
    role: role,
    scope: scope
  }];
  if (_RoleHelper.RoleHelper.hasTeamAdminWithoutEventRole(user, teamId, eventId)) {
    return children;
  }
  if (!_RoleHelper.RoleHelper.hasSome(user, roles)) return _react["default"].createElement("span", null);
  return children;
}
var DisplayForAdmin = exports.DisplayForAdmin = function DisplayForAdmin(_ref2) {
  var teamId = _ref2.teamId,
    eventId = _ref2.eventId,
    includeTeamAdmin = _ref2.includeTeamAdmin,
    children = _ref2.children,
    user = _ref2.user;
  return _react["default"].createElement(DisplayForRole, {
    user: user,
    roles: _RoleHelper.RoleHelper.eventAdminRoles(teamId, eventId, includeTeamAdmin),
    teamId: teamId,
    eventId: eventId
  }, children);
};
var DisplayForNonAdmin = exports.DisplayForNonAdmin = function DisplayForNonAdmin(_ref3) {
  var teamId = _ref3.teamId,
    eventId = _ref3.eventId,
    children = _ref3.children,
    user = _ref3.user;
  return _react["default"].createElement(DisplayForRole, {
    user: user,
    roles: _RoleHelper.RoleHelper.eventNonAdminRoles(eventId),
    teamId: teamId,
    eventId: eventId
  }, children);
};
var DisplayForTeamAdmin = exports.DisplayForTeamAdmin = function DisplayForTeamAdmin(_ref4) {
  var teamId = _ref4.teamId,
    children = _ref4.children,
    user = _ref4.user;
  return _react["default"].createElement(DisplayForRole, {
    user: user,
    roles: _RoleHelper.RoleHelper.teamAdminRoles(teamId)
  }, children);
};